export default __webpack_public_path__ + "static/media/ic_vanuatu.dc5199e7.svg";